import styled from 'styled-components';
import { device } from '@components/utils/breakpoints';

export const Heading = styled.div<{
    $as: string;
    $desktopSize: string;
    $mobileSize: string;
    $headerColor: string;
}>`
    font-family: UxumGrotesque, var(--font-uxum), -apple-system,
        BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif;

    font-weight: 700;

    font-size: ${(props) => props.$mobileSize};
    color: ${(props) => props.$headerColor};

    line-height: 1.25em;
    margin: 0;
    font-weight: bold;

    @media (max-width: 320px) {
        font-size: ${(props) => props.$mobileSize};
    }

    @media ${device.md} {
        font-size: ${(props) => props.$mobileSize};
    }

    @media ${device.lg} {
        font-size: ${(props) => props.$desktopSize};
    }

    @media ${device.xl} {
        font-size: ${(props) => props.$desktopSize};
    }
`;
